import { BaseResponse } from './base-response.model';
import {
	CallingTreeMember,
	CallingTreeMemberJSON,
} from './calling-tree-member.model';

export interface CallingTreeBranchViewResponse extends BaseResponse {
	message: string;
	view: CallingTreeViewJSON;
}

export interface CallingTreeBranchViewJSON {
	branch: number;
	coordinator: CallingTreeMemberJSON;
	backup: CallingTreeMemberJSON;
	members: CallingTreeMemberJSON[];
}

export class CallingTreeBranchView {
	constructor(
		public branch: number,
		public coordinator: CallingTreeMember,
		public backup: CallingTreeMember,
		public members: CallingTreeMember[]
	) {}

	static fromJSON(json: CallingTreeBranchViewJSON): CallingTreeBranchView {
		return Object.assign(
			Object.create(CallingTreeBranchView.prototype),
			json,
			{
				coordinator: json.coordinator
					? CallingTreeMember.fromJSON(json.coordinator)
					: null,
				backup: json.backup
					? CallingTreeMember.fromJSON(json.backup)
					: null,
				members: json.members
					? json.members.map((member) =>
							CallingTreeMember.fromJSON(member)
						)
					: [],
			}
		);
	}
}

export interface CallingTreeSuperCoordinatorViewJSON {
	superCoordinator: CallingTreeMemberJSON;
	branches: CallingTreeBranchViewJSON[];
}

export class CallingTreeSuperCoordinatorView {
	constructor(
		public superCoordinator: CallingTreeMember,
		public branches: CallingTreeBranchView[]
	) {}

	static fromJSON(
		json: CallingTreeSuperCoordinatorViewJSON
	): CallingTreeSuperCoordinatorView {
		return Object.assign(
			Object.create(CallingTreeSuperCoordinatorView.prototype),
			json,
			{
				superCoordinator: json.superCoordinator
					? CallingTreeMember.fromJSON(json.superCoordinator)
					: null,
				branches: json.branches
					? json.branches.map((branch) =>
							CallingTreeBranchView.fromJSON(branch)
						)
					: [],
			}
		);
	}
}

export interface CallingTreeViewJSON {
	root: CallingTreeMemberJSON;
	manager: CallingTreeMemberJSON;
	superCoordinatorViews: CallingTreeSuperCoordinatorViewJSON[];
}

export class CallingTreeView {
	constructor(
		public root: CallingTreeMember,
		public manager: CallingTreeMember,
		public superCoordinatorViews: CallingTreeSuperCoordinatorView[]
	) {}

	static fromJSON(json: CallingTreeViewJSON): CallingTreeView {
		return Object.assign(Object.create(CallingTreeView.prototype), json, {
			root: json.root ? CallingTreeMember.fromJSON(json.root) : null,
			manager: json.manager
				? CallingTreeMember.fromJSON(json.manager)
				: null,
			superCoordinatorViews: json.superCoordinatorViews
				? json.superCoordinatorViews.map((scv) =>
						CallingTreeSuperCoordinatorView.fromJSON(scv)
					)
				: [],
		});
	}
}
